<template>
  <div class="Container" />
</template>

<script>
export default {
  name: 'ErrorChip'
}
</script>

<style lang="scss" scoped>
.Container {
  height: 30px;
  width: 30px;
  border-radius: 15px;
  background-color: red;
}
</style>
